import { useCallback, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import {
  ISearchSchedulesQuery,
  ISearchSchedulesQueryVariables,
  PermissionKey,
  ScheduleType,
} from '../../../utils/apollo/graphqlSchema';
import SEARCH_SCHEDULES from '../apollo/SEARCH_SCHEDULES';
import { useDispatch } from 'react-redux';
import { setDictionaryListAction } from '../../../redux/slices/dictionary';
import { DictionaryTypeEnum } from '../../../utils/interfaces';
import { clearSchedulesAction } from '../../../redux/actions/scheduler';
import usePermission from '../../../utils/hooks/permissionHooks/usePermission';

interface IProps {
  schemaId: string;
  searchTerm: string;
}
export default ({ schemaId, searchTerm }: IProps) => {
  const dispatch = useDispatch();
  const { checkIsPermitted } = usePermission();
  const isPermittedToReadAnalysisSchedule = checkIsPermitted({
    requiredPermissionKeys: [PermissionKey.AnalysisScheduleRead],
    schemaId,
  });
  const onCompleted = useCallback(
    ({ searchSchedules }: ISearchSchedulesQuery) => {
      dispatch(
        setDictionaryListAction({
          newValues: searchSchedules?.entities ?? [],
          dictionaryType: DictionaryTypeEnum.ScheduleAnalysis,
        }),
      );
    },
    [dispatch],
  );

  const { loading } = useQuery<
    ISearchSchedulesQuery,
    ISearchSchedulesQueryVariables
  >(SEARCH_SCHEDULES, {
    variables: {
      types: [ScheduleType.Analysis],
      schemaKey: schemaId,
      term: searchTerm,
      includes: [],
      pagination: { after: 0, first: 0 },
    },
    onCompleted,
    skip: !isPermittedToReadAnalysisSchedule,
  });

  useEffect(() => {
    return () => {
      dispatch(clearSchedulesAction());
    };
  }, [dispatch]);

  return loading;
};
